import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=ec202124&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec202124')) {
      api.createRecord('ec202124', component.options)
    } else {
      api.reload('ec202124', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=ec202124&", function () {
      api.rerender('ec202124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25fBCgDQAMkcP/JS/comp/pricelist.vue"
export default component.exports